import { render, staticRenderFns } from "./table-ongoing.component.vue?vue&type=template&id=4b585f0a&scoped=true"
import script from "./table-ongoing.component.vue?vue&type=script&lang=js"
export * from "./table-ongoing.component.vue?vue&type=script&lang=js"
import style0 from "./table-ongoing.component.vue?vue&type=style&index=0&id=4b585f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b585f0a",
  null
  
)

export default component.exports